import Config from "@/const/Config";
import { AuthCheckerService } from "@/service/AuthCheckerService";
import { DialogService } from "@/service/DialogService";
import { useAuthStore } from "@/store/auth";
import { TenpuFile } from "@/types/TenpuFile";

export function useFileDownload() {
  const fileDownload = (tenpuFile: TenpuFile) => {
    if(tenpuFile.tenpufile_id === null){
      return
    }
    exec(tenpuFile)
  }

  const fileOpenNewTab = async (tenpuFile: TenpuFile) => {
    if(tenpuFile.tenpufile_id === null){
      return
    }
    execNew(tenpuFile.tenpufile_id)
  }

  const execNew = async (id: number | null) => {
    
    // apiによるファイル権限チェック
    const authStore = useAuthStore()
    if (!authStore.user) {
      return
    }
    const srv = new AuthCheckerService()
    const res = await srv.tenpuFileControl(authStore.user.user_id)
    if (!res) {
      return
    }
    let path = Config.API_URL + "/tenpufile/open/" + id;
    window.open(path, '_blank');
  }

  const exec = async (tenpuFile: TenpuFile) => {
    DialogService.question({
      text: 'ファイルをダウンロードしますか？',
      showCancelButton: true,
      confirmButtonText: 'ダウンロードします',
      cancelButtonText: 'キャンセル',
    }).then(async(result) => {
      if (result.isConfirmed) {
        // apiによるファイル権限チェック
        const authStore = useAuthStore()
        if (!authStore.user) {
          return
        }
        const srv = new AuthCheckerService()
        const res = await srv.tenpuFileControl(authStore.user.user_id)
        if (!res || !tenpuFile.file) {
          return
        }
        let link = document.createElement('a');
        let path = Config.API_URL + "/tenpufile/download/" + tenpuFile.tenpufile_id;
        link.href = path
        link.click();
        link.remove();
      }
    });
  }

  return {
    fileDownload,
    fileOpenNewTab,
    thumbBaseUrl: Config.THUMB_BASE_URL
  }
}
